import React, {useEffect} from "react";
import moment from "moment";
import {Delete, Recycling} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import ApiClient from "../../API";
import {useQueryClient, useMutation} from "react-query";
import {Button} from "@mui/material";


export default function Notification({notification, allowMarkViewed=true}) {
    const dateLocaleString = new Date(notification.created_at).toLocaleString()
    const dateHumaneString = moment(notification.created_at).fromNow();

    const queryClient = useQueryClient();
    const viewedMutation = useMutation(() => {
        return ApiClient().post(`/broadcast/${notification.id}/viewed/`, {})
    }, {
        retry: 3
    })

    const dismissedMutation = useMutation(() => {
        return ApiClient().post(`/broadcast/${notification.id}/dismiss/`, {})
    }, {
        onSuccess: () => {
            console.log("dismissed via API")
            return queryClient.invalidateQueries(['broadcast_notifications'])
        }
    }, {
        retry: 3
    })

    const dismissAction = () => {
        dismissedMutation.mutate()
        // locally modify the broadcast_notifications data
        queryClient.setQueryData(['broadcast_notifications'], (oldData) => {
            if (!oldData) return oldData;
            return oldData.map((n) => n.id === notification.id ? { ...n, is_dismissed: true } : n);
        });
    }

    useEffect(() => {
        if (allowMarkViewed && !notification.is_dismissed ) {
            viewedMutation.mutate()
        }
    }, [allowMarkViewed])

    return (
        <div className="notification p-3 border-bottom">
            {
                !notification.is_dismissed && <Button
                    onClick={() => dismissAction()}
                    className="float-end text-small bold text-danger m-0 p-0">
                    <CloseIcon />
                </Button>
            }


            <small className="float-end text-black-50" title={dateLocaleString}>
                {dateHumaneString}
            </small>

            <h5>{notification.title}</h5>

            <p>{notification.message}</p>

        </div>
    );
}
